import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { submitSoftwareRequest, clearSoftwareRequestStatus } from "../slice";
import "./requestSoftwareModal.css";

const RequestSoftwareModal = ({
  show,
  onHide,
  onSubmitSuccess,
  onSubmitError,
}) => {
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState("");

  const { submitSoftwareRequestStatus, submitSoftwareRequestError } =
    useSelector((state) => state.templates);

  const isSubmitting = submitSoftwareRequestStatus === "loading";

  // Handle successful submission
  useEffect(() => {
    if (submitSoftwareRequestStatus === "success") {
      // Clear the input and close modal
      setInputValue("");
      onHide();

      // Trigger success toast
      onSubmitSuccess();

      // Clear the status
      dispatch(clearSoftwareRequestStatus());
    }
  }, [submitSoftwareRequestStatus, onHide, onSubmitSuccess, dispatch]);

  // Handle error - trigger error toast
  useEffect(() => {
    if (submitSoftwareRequestStatus === "failed") {
      // Error handled by component UI
      // Trigger error toast
      onSubmitError(submitSoftwareRequestError);

      // Clear the status
      dispatch(clearSoftwareRequestStatus());
    }
  }, [
    submitSoftwareRequestStatus,
    submitSoftwareRequestError,
    onSubmitError,
    dispatch,
  ]);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleSubmit = async () => {
    if (!inputValue.trim()) return;

    dispatch(submitSoftwareRequest(inputValue.trim()));
  };

  const handleClose = () => {
    setInputValue("");
    dispatch(clearSoftwareRequestStatus());
    onHide();
  };

  const isSubmitDisabled = !inputValue.trim() || isSubmitting;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className="request-software-modal"
    >
      <Modal.Body className="pt-0">
        <Modal.Header className="modal-title-with-border mb-0" closeButton>
          <Modal.Title>Let us know your needs</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>
              What software do you use and want us to support next?
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={inputValue}
              onChange={handleInputChange}
              placeholder="Tell us about the software you'd like us to support..."
              disabled={isSubmitting}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={isSubmitDisabled}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};

export default RequestSoftwareModal;
